import { IgDialog } from "@intelligems/ig-theme";
import Box from "@mui/material/Box";
import { CreateRuleForm, type CreateRuleFormProps } from "./CreateRuleForm";

export type CreateRuleDialogViewProps = Omit<
  CreateRuleFormProps,
  "templateCardSize" | "composerSurface"
> & {
  open: boolean;
  onClose: () => void;
};

/**
 * The rule creation form as a modal, opened from the rules list.
 *
 * The dialog carries no action buttons: every way out of it is a choice inside
 * the form — build with Atlas, pick a template, or write the code yourself —
 * and a trailing "Create" would name none of them.
 */
export const CreateRuleDialogView = ({
  open,
  onClose,
  ...formProps
}: CreateRuleDialogViewProps) => (
  <IgDialog
    showDialog={open}
    title="Create a new rule"
    subtitle={
      <Box sx={{ mt: "-16px" }}>
        Describe which products should show and for whom — or start from a
        template and Atlas fills in the rest.
      </Box>
    }
    maxWidth="md"
    minWidth="0"
    // MUI's DialogContent scrolls on the y axis, which per spec forces the x
    // axis to clip too — shearing the composer's focus glow off at its left
    // and right edges. The dialog's own 24px padding is the room it needs.
    sx={{ "& .MuiDialogContent-root": { overflow: "visible" } }}
    hideActions
    showCloseIcon
    handleClose={onClose}
    rawContent={
      <Box sx={{ mt: "-24px" }}>
        <CreateRuleForm
          {...formProps}
          templateCardSize={{ xs: 10, sm: 5 }}
          composerSurface="plain"
        />
      </Box>
    }
  />
);
